const allMenus = [
  {
    name: "Solutions",
    type: "mega",
    columns: [
      {
        heading: "Warehousing",
        link: "/warehousing",
        items: [
          { name: "Shared Warehousing", link: "/warehousing/shared", icon: "mdi mdi-account-group-outline" },
          { name: "Dedicated Warehousing", link: "/warehousing/dedicated", icon: "mdi mdi-office-building" },
          { name: "Managed Warehousing", link: "/warehousing/managed", icon: "mdi mdi-cog-outline" },
          { name: "On-Demand Warehousing", link: "/warehousing/on-demand", icon: "mdi mdi-lightning-bolt-outline" },
          { name: "4PL Aggregation", link: "/warehousing/4pl-aggregation", icon: "mdi mdi-hub" },
        ],
      },
      {
        heading: "Fulfilment",
        link: "/warehousing",
        items: [
          { name: "Quick Commerce", link: "/warehousing/quick-commerce", icon: "mdi mdi-clock-fast" },
          { name: "B2C Marketplace", link: "/warehousing/b2c-marketplace", icon: "mdi mdi-shopping-outline" },
          { name: "D2C Webstore", link: "/warehousing/d2c-webstore", icon: "mdi mdi-web" },
          { name: "General & Modern Trade", link: "/warehousing/general-modern-trade", icon: "mdi mdi-store-outline" },
          { name: "B2B & EBO Distribution", link: "/warehousing/b2b-orders-distribution", icon: "mdi mdi-truck-delivery-outline" },
        ],
      },
      {
        heading: "Logistics",
        link: "/logistics/surface-air-delivery",
        items: [
          { name: "Surface & Air Delivery", link: "/logistics/surface-air-delivery", icon: "mdi mdi-airplane" },
          { name: "Same-Day & NDD", link: "/logistics/same-day-next-day-delivery", icon: "mdi mdi-timer-outline" },
          { name: "Metro Express", link: "/logistics/metro-to-metro-next-day-delivery", icon: "mdi mdi-city-variant-outline" },
          { name: "PTL / LTL Freight", link: "/logistics/appointment-based-deliveries", icon: "mdi mdi-truck-outline" },
          { name: "Appointment Deliveries", link: "/logistics/appointment-based-deliveries", icon: "mdi mdi-calendar-check-outline" },
          { name: "Hyperlocal Delivery", link: "/logistics/hyperlocal-delivery", icon: "mdi mdi-map-marker-radius-outline" },
          { name: "Milk Run Vehicles", link: "/logistics/dedicated-milk-run-vehicles", icon: "mdi mdi-bus-clock" },
        ],
      },
      {
        heading: "Value-Added",
        link: "/packaging-material",
        items: [
          { name: "Packing Material", link: "/packaging-material", icon: "mdi mdi-package-variant" },
          { name: "Pick, Pack & Ship", link: "/warehousing/pick-pack-ship", icon: "mdi mdi-cube-send" },
          { name: "Packaging & Labeling", link: "/warehousing/labeling-barcoding", icon: "mdi mdi-label-outline" },
          { name: "Kitting & Assembly", link: "/warehousing/kitting-value-added-services", icon: "mdi mdi-puzzle-outline" },
          { name: "Returns Processing", link: "/warehousing/return-processing-centres", icon: "mdi mdi-swap-horizontal" },
        ],
      },
    ],
  },
  {
    name: "Platform",
    type: "mega",
    columns: [
      {
        heading: "Order Management",
        link: "/technology/order-management-system",
        items: [
          { name: "Multi-Channel OMS", link: "/technology/order-management-system", icon: "mdi mdi-layers-outline" },
          { name: "50+ Integrations", link: "/technology/order-management-system#oms-marketplaces", icon: "mdi mdi-link-variant" },
          { name: "Intelligent Routing", link: "/technology/order-management-system#oms-routing", icon: "mdi mdi-directions-fork" },
          { name: "Common Inventory Pool", link: "/technology/order-management-system#oms-inventory", icon: "mdi mdi-database" },
          { name: "ERP Integrations", link: "/technology/order-management-system#oms-erp", icon: "mdi mdi-api" },
        ],
      },
      {
        heading: "Warehouse Tech (WMS)",
        link: "/technology/warehouse-management-system",
        items: [
          { name: "Inventory Governance", link: "/technology/wms/inventory-governance", icon: "mdi mdi-clipboard-list-outline" },
          { name: "Pick, Pack & Dispatch", link: "/technology/wms/pick-pack-dispatch", icon: "mdi mdi-hand-pointing-right" },
          { name: "Governance & Compliance", link: "/technology/wms/governance-compliance", icon: "mdi mdi-shield-account-outline" },
          { name: "Shelf Life & Batch Control", link: "/technology/wms/shelf-life-management", icon: "mdi mdi-calendar-clock" },
          { name: "Scan, Camera & Automation", link: "/technology/wms/warehouse-automation", icon: "mdi mdi-barcode-scan" },
        ],
      },
      {
        heading: "Freight Tech (TMS)",
        link: "/technology/freight-management-system",
        items: [
          { name: "PACE Engine", link: "/technology/freight-management-system#fms-pace", icon: "mdi mdi-brain" },
          { name: "Courier Allocation", link: "/technology/freight-management-system#fms-capabilities", icon: "mdi mdi-account-switch-outline" },
          { name: "NDR & NPR Management", link: "/logistics/ndr-npr-management/", icon: "mdi mdi-phone-return-outline" },
          { name: "Returns Management", link: "/logistics/returns-management-system", icon: "mdi mdi-backup-restore" },
          { name: "Enterprise Features", link: "/technology/enterprise-features", icon: "mdi mdi-shield-star-outline" },
        ],
      },
      {
        heading: "Control Tower",
        link: "/technology/control-tower",
        items: [
          { name: "SLA Management", link: "/technology/control-tower#ct-warehousing-performance", icon: "mdi mdi-chart-timeline-variant" },
          { name: "Breach Prevention", link: "/technology/control-tower#ct-sla-heading", icon: "mdi mdi-alert-circle-check-outline" },
          { name: "Manpower Planning", link: "/technology/control-tower#ct-manpower-heading", icon: "mdi mdi-account-hard-hat" },
          { name: "Inventory Health", link: "/technology/control-tower#ct-inventory-health", icon: "mdi mdi-heart-pulse" },
          { name: "Command Centre", link: "/technology/control-tower#ct-logistics-performance", icon: "mdi mdi-monitor-dashboard" },
        ],
      },
    ],
    featured: {
      title: "ProPilot - Your AI Ally",
      desc: "AI-powered supply chain assistant for real-time insights, anomaly detection, and operational intelligence.",
      link: "/technology/propilot",
      cta: "Explore ProPilot",
    },
  },
  {
    name: "Hyperlocal",
    type: "simple",
    items: [
      { name: "Hyperlocal Fulfilment", link: "/hyperlocal-delivery" },
      { name: "Before You Go Hyperlocal", link: "/hyperlocal-delivery-planning" },
    ],
  },
  {
    name: "Company",
    type: "simple",
    items: [
      { name: "Leadership", link: "/about-us/leadership" },
      { name: "Our Clients", link: "/about-us/our-clients" },
      { name: "Case Studies", link: "/case-studies" },
      { name: "How We Work", link: "/about-us/contact" },
      { name: "Fulfilment Network", link: "/about-us/pfn" },
      { name: "Supply Chain Academy", link: "/academy" },
      { name: "In the News", link: "/media" },
    ],
  },
  {
    name: "Login",
    type: "simple",
    items: [
      { name: "Control Tower", link: "https://ct.prozo.com" },
      { name: "WMS Login", link: "https://wms.prozo.com" },
      { name: "TMS Login", link: "https://www.proship.in" },
    ],
  },
];

export default allMenus;
